import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';

import { PwaInstallService } from './core/services/pwa-install.service';
import { SwUpdateService } from './core/services/sw-update.service';
import { AuthService } from './core/services/auth.service';
import { ThemeService } from './core/services/theme.service';
import { AppLogo } from './shared/components/app-logo/app-logo';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatButtonModule, MatIconModule, AppLogo],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  /** Keep the service constructed so update checks start at bootstrap. */
  protected readonly swUpdate = inject(SwUpdateService);
  protected readonly pwaInstall = inject(PwaInstallService);

  constructor() {
    const auth = inject(AuthService);
    if (auth.isAuthenticated()) {
      const user = auth.getUser();
      inject(ThemeService).initialize(user?.user_id ?? (user?.id ? String(user.id) : null));
    }
  }
}
